module.exports = __webpack_public_path__ + "static/media/kiss.f4e8ef31.svg";